<template>
  <v-container fluid style="width: 100%; padding: 0" class="fontscolor">
    <Header />

    <article class="mobile-center">
      <section class="fw-section">
        <div style="background-color: #edf4fe">
          <div class="container fullwidthsec">
            <div class="row" style="padding-top: 50px">
              <div class="page-title title-size-normal text-dark"></div>
            </div>

            <div class="container fullwidthsec">
              <div
                style="font-size: 26px; font-weight: bold; padding-bottom: 10px"
              >
                Terms of Service
              </div>

              The Agreement Between You And Maposcope Marcin Wider (Maposcope
              app team)
              <br /><br />
              By registering or using the Service and accepting this Terms, you
              agree that you are accepting this Terms on behalf of yourself and
              any of your Team members that are linked to your Account, and that
              you are solely responsible and liable for any non-compliance. You
              further represent that you are authorized to accept these terms
              and conditions. If you cannot accept this Agreement, please do not
              use the Service.
              <br /><br />
              Maposcope app team reserves the right to modify the Terms at any
              time without notice to you. Any changes will be effective
              immediately upon posting the revised version. Your use of this
              Service constitutes your agreement to all such terms, conditions,
              and notices.
              <br /><br />
              License
              <br />
              The Service is licensed, not sold, to You under these Terms. If
              you receive Software from us such as the mobile application that
              You install on your mobile device (“Software”), its use is
              governed in one of two ways: If you’re presented with license
              terms that you must accept in order to use the Software, those
              terms apply; if no license is presented to you, these Terms apply.
              Your license is automatically revoked if you violate these Legal
              Terms.
              <br /><br />
              Software – Maposcope app team hereby grants you limited,
              non-exclusive, non-transferable, non-sub-licensable, revocable
              “Free of charge” perpetual license to use the Software subject to
              these Terms.
              <br /><br />
              Server – All features accessible to you after successful
              Registration (“Server”) are licensed to you under subscription
              license Plans. Maposcope app team hereby grants you limited,
              non-exclusive, non-transferable, non-sub-licensable, revocable
              license to use the Server subject to all Legal Terms.
              <br /><br />
              Maposcope app team shall have a royalty-free, worldwide,
              transferable, sub-licensable, irrevocable, and perpetual license
              to incorporate into the Service or otherwise use any suggestions,
              enhancement requests, recommendations or other feedback we receive
              from you.
              <br /><br />
              Service Available “AS-IS”
              <br />
              You understand that our service is provided “AS IS”, at your own
              risk, without WARRANTY OF ANY KIND. Maposcope app team does not
              warrant that the the service will be uninterrupted, timely,
              error-free or completely secure. You acknowledge and agree that
              Maposcope app team is dependent on the performance of the third
              parties and therefore Maposcope app team is in no way responsible
              for:
              <br />
              (A) the quality, reliability, speed and/or availability of the
              Internet Services that you need to access our Service<br />
              (B) the GPS signal quality, reliability and/or availability<br />
              (C) hosting services<br />
              (D) accuracy of the mileage, altitude, speed and other data
              calculated based on your device GPS data<br />
              (E) the installation, operation, quality of transmission, cost, or
              maintenance of any mobile devices or equipment required to utilize
              the Services<br />
              (F) any external legal issues or requirements that you may come
              under when using the Service<br />
              <br /><br />
              Account Security
              <br />
              You are entirely responsible for maintaining the confidentiality
              of your password and account. Furthermore, you are entirely
              responsible for any and all activities that occur under your
              account including activities of your team members that you have
              invited. You agree to notify Maposcope app team immediately of any
              unauthorized use of your account or any other breach of security.
              Maposcope app team may suspend access to your account, or close
              your account, with or without notice according to these Terms if
              you:
              <br /><br />
              (A) provide any information that is false, inaccurate, out of
              date, or incomplete<br />
              (B) breach or violate any of these Legal Terms<br />
              (c) do not pay subscription fees or other sums due<br />
              <br /><br />

              We reserves the right to refuse service to users for any reason.
              If a user is a paid customer subscription dues will be refunded
              for the current month.
              <br /><br /><br /><br />

              <h3>PAYMENT TERMS</h3>
              <br /><br />
              (Last Updated: 15-06-2022)
              <br /><br />
              These “Payment Terms” apply whenever you elect to purchase a
              subscription plan from us. By purchasing a subscription from
              Maposcope app team, you agree to be legally bound by these Payment
              Terms. We might periodically amend this policy for any reason. By
              “Server” we mean all online cloud-based Web features available to
              you after successful Account registration/login.
              <br /><br />
              Plans and Billing
              <br />
              The Server license is made available on pay-as-you go basis and is
              available to you from the date you elect to buy a subscription
              plan (“Plan”). All Plans are prepaid for the period selected
              (monthly or annual) and renew automatically until you cancel or
              Maposcope app team terminates it. If you purchase a Plan you agree
              and authorize Maposcope app team or its third party payment
              providers to charge your credit card monthly or yearly, for all
              applicable fees, on the date you purchase the Plan, subject to the
              procedures and rules contained in these Payment Terms. If your
              Plan began on a day not contained in a subsequent month (e.g.,
              your service began on January 30, and there is no February 30), we
              will process your payment on the last day of such month. You agree
              that we have permission to share with third party financial
              institutions and payment processing firms your billing and payment
              information for the purpose of processing payment. You must keep
              all billing information accurate.
              <br /><br />
              Free Trail
              <br />
              Free trial – The first 10 days after you register your Server
              account are absolutely free and you may cancel at any time. You
              will lose access to selected Premium features and you will not be
              able to access your data on the Server anymore. We strongly advise
              that you sync, print or export your map data prior end of your
              trial. If you decide to buy any subscription plan we will
              immediately enable all premium features. You can change
              subscription billing periods during your free trial. After trial
              period, it will not be possible to switch from the Annual
              subscription plan to monthly subscription until Annual
              subscription plan renewal date takes place.

              <div class="col-sm-3"></div>
            </div>
          </div>
        </div>
      </section>
    </article>

    <Footer />
    <vue-cookies-consent
      backgroundButton="#1972f5"
      borderRadius="5"
      backgroundButtonHover="#3A4F52"
      offsetY="5"
      style="z-index: 1000"
    >
      <template #description>
        <p>
          We use cookies to ensure you get the best experience on our website
          <router-link to="privacy-policy"
            ><span style="color: #0a64eb">Read more</span></router-link
          >
        </p>
      </template>
      <template #button>Accept cookies</template>
    </vue-cookies-consent>
  </v-container>
</template>

<script>
import VueCookiesConsent from "@norvikit/vue-cookies-consent";
export default {
  components: {
    VueCookiesConsent,
  },
};
</script>


<style scoped>
a {
  color: red;
}
.error-msg {
  color: red;
  font-weight: bold;
}

.wlink a,
a:active,
a:hover {
  color: #2c405a !important;
}
.v-application a {
  color: #2c405a !important;
}

.btnl1 {
  color: #ffffff !important;
  background-color: #1972f5;
}

.btnl1:hover {
  background-color: #0a64eb;
}

.btnl2 {
  color: #ffffff !important;
  background-color: #eceff6;
}

.btnl2:hover {
  background-color: #eceff6;
}
.fullwidthsec {
  max-width: 1200px;
}

ul li::before {
  content: "";
}

ul li {
  content: "";
}
@media only screen and (max-width: 600px) {
  .fullwidthsec {
    max-width: 350px;
  }
}
</style>